import { render, staticRenderFns } from "./unitCommon.vue?vue&type=template&id=016a40f4&scoped=true&"
import script from "./unitCommon.vue?vue&type=script&lang=js&"
export * from "./unitCommon.vue?vue&type=script&lang=js&"
import style0 from "./unitCommon.vue?vue&type=style&index=0&id=016a40f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016a40f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('016a40f4')) {
      api.createRecord('016a40f4', component.options)
    } else {
      api.reload('016a40f4', component.options)
    }
    module.hot.accept("./unitCommon.vue?vue&type=template&id=016a40f4&scoped=true&", function () {
      api.rerender('016a40f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/insurance/unitCommon.vue"
export default component.exports